import React, { useEffect, useState } from "react";
import { PresentGoodsParts, PresentCheckSelectColorParts, PresentCheckParts } from "../Parts/presentParts"; 
import Data from "src/data/presents.json"


export const PresentView = (props) => {
	
	const [selectPresent, setSelectPresent] = useState(props.defaultPresent.id)

	const onSelectPresent = (e) => {

		props.setValue('id', e.target.value)	
		setSelectPresent(e.target.value)
		// チェックボックス要素を名前で取得
		const checkboxes = document.getElementsByName('prize');

		// 取得したチェックボックスをループしてチェックを外す
		checkboxes.forEach((checkbox) => {
			　if(checkbox.value !== e.target.value) checkbox.checked = false;
		});

	}


    return (
        <div>
        <ul className="tile a1-b2 am20-bm10-cm20">
				{
					Data.data.map((p,i) => {
						let checked
						selectPresent === p.id ? checked = true : checked = false
						return (
							<li key={p.id}>
								<div className="prizebox">
									<PresentGoodsParts
											key={p.id}
											{...{present:p}}
										>
									</PresentGoodsParts>
									{
									p.colorSelect === false && 
										<PresentCheckParts {...{
											index:i,
											present:p, 
											checked,
											onSelectPresent,
											}}></PresentCheckParts>
									}
									{
										p.colorSelect === true && 
										<PresentCheckSelectColorParts {...{
											index:i,
											present:p, 
											onSelectPresent,
											checked,
											defaultColor: props.defaultPresent.color,
											register:props.register
											}}></PresentCheckSelectColorParts>
									}
								</div>
							</li>
						)
						
					})
				}
				
			</ul>
        </div>
    )
}